/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseMoveResultData } from './genericApiResponseMoveResultData';
import type { GenericApiResponseMoveResultMessage } from './genericApiResponseMoveResultMessage';
import type { GenericApiResponseMoveResultPagination } from './genericApiResponseMoveResultPagination';
import type { GenericApiResponseMoveResultError } from './genericApiResponseMoveResultError';

export interface GenericApiResponseMoveResult {
  data?: GenericApiResponseMoveResultData;
  message?: GenericApiResponseMoveResultMessage;
  pagination?: GenericApiResponseMoveResultPagination;
  error?: GenericApiResponseMoveResultError;
  statusCode?: number;
}
